var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmriIPerdoruesit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#fff",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,8c2.2,0,4-1.8,4-4s-1.8-4-4-4S4,1.8,4,4 S5.8,8,8,8z M8,10c-2.7,0-8,1.3-8,4v1c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-1C16,11.3,10.7,10,8,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmriIPerdoruesit);
export default __webpack_public_path__ + "static/media/icon_emri_i_perdoruesit.fffe7936b060438a4109b15254bf8c7a.svg";
export { ForwardRef as ReactComponent };